import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RequestMetaService {

  private requestId: string = null;
  private spanId: string = null;

  set(headers: HttpHeaders): void {
    if (!headers) {
      return;
    }
    this.requestId = headers.get('x-request-id') ?? this.requestId;
    this.spanId = headers.get('s1-span-id') ?? this.spanId;
  }

  get(): { requestId: string, spanId: string } {
    return { requestId: this.requestId, spanId: this.spanId };
  }

}
